import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import { ScrollReveal } from '@/components/base/ScrollReveal';
import Hero from './components/Hero';
import BrandSummary from './components/BrandSummary';
import NewReleases from './components/NewReleases';
import StorePartners from './components/StorePartners';
import HomeFAQ from './components/HomeFAQ';
import ContentTrust from './components/ContentTrust';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '清文華泉事業有限公司',
  alternateName: ['清文華泉', 'CINVA'],
  description:
    '清文華泉以 AIGC 彩色書籍、科普與歷史類書籍為主要出版方向。本品牌委託崧博出版經銷，官方網站由崧博出版製作。',
  url: 'https://cinva.sonbook.net/',
  logo: 'https://storage.readdy-site.link/project_files/5a105479-8d38-448e-9522-af2f638a0e72/43972714-abc7-46e0-b45a-08a831bb46bf_logo-02-01.png',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

export default function Home() {
  useEffect(() => {
    document.title = '清文華泉｜彩色科普、歷史與AIGC視覺書籍';
  }, []);

  return (
    <>
      <JsonLd data={organizationSchema} />
      <Navbar />
      <main>
        <Hero />
        <ScrollReveal direction="up">
          <BrandSummary />
        </ScrollReveal>
        <ScrollReveal direction="up">
          <NewReleases />
        </ScrollReveal>
        <ScrollReveal direction="up">
          <StorePartners />
        </ScrollReveal>
        <ScrollReveal direction="up">
          <HomeFAQ />
        </ScrollReveal>
        <ScrollReveal direction="up">
          <ContentTrust />
        </ScrollReveal>
      </main>
      <Footer />
    </>
  );
}